import { IAutoApproveSetting } from 'utils/commonTypes';
import { helper } from 'utils/helper';
import * as Yup from 'yup';

declare module 'yup' {
  // @ts-ignore
  interface NumberSchema<T extends number | null | undefined = number> {
    matches(length: RegExp, message: string): NumberSchema<T>;
  }
}

const autoApproveSchema = () =>
  Yup.object().shape({
    isActive: Yup.boolean(),
    positionsFrom: Yup.number()
      .nullable()
      .when('isActive', {
        is: true,
        then: Yup.number()
          .required("Обов'язкове поле")
          .test(
            'is-greater-than-positionsFrom',
            'Кількість позицій повина бути більше нуля і більше попередньої верхньої межі',
            function (value) {
              // const index = helper.getIndexFromAutoapproveListPath(this.path);

              // @ts-ignore
              const index = this?.options?.index;

              if (index === 0) {
                return true;
              }

              // @ts-ignore
              const autoApproveList = this?.options?.from[1]?.value?.autoApproveList || [];

              const prevData = autoApproveList.slice(0, index);

              const activePrevData = prevData.filter((curData: IAutoApproveSetting) => curData.isActive);

              if (activePrevData.length === 0) {
                return value ? value > 0 : false;
              }

              const previousEdgeValue = activePrevData[activePrevData.length - 1]?.positionsTo;

              return value ? value > previousEdgeValue : false;
            },
          ),
      }),
    positionsTo: Yup.number()
      .nullable()
      .when('isActive', {
        is: true,
        then: Yup.number()
          .required("Обов'язкове поле")
          .test(
            'is-greater-than-positionsFrom',
            'Кількість позицій до повинна бути більше нуля і не менша за кількість позицій від',
            function (value) {
              // @ts-ignore
              const index = this?.options?.index;

              if (index === 0) {
                return value ? value > 0 : false;
              }

              // @ts-ignore
              const autoApproveList = this?.options?.from[1]?.value?.autoApproveList || [];

              if (index === autoApproveList.length - 1) {
                return true;
              }

              return value ? value >= this.parent.positionsFrom : false;
            },
          ),
      }),
    timeToWaitMin: Yup.number()
      .nullable()
      .when('isActive', {
        is: true,
        then: Yup.number()
          .required("Обов'язкове поле")
          .test('is-positive-number', 'Час очікування має бути більше нуля', function (value) {
            const index = helper.getIndexFromAutoapproveListPath(this.path);

            if (index === 0) {
              return true;
            }

            return value ? value > this.parent.positionsFrom : false;
          }),
      }),
  });

// const validateAutoApproveList = (list: IAutoApproveSetting[]) => {
//   let isValid = true;

//   for (let i = 1; i < list.length; i += 1) {
//     if (list[i].isActive && list[i - 1].isActive) {
//       if (list[i].positionsFrom !== null && list[i - 1].positionsTo !== null) {
//         if (list[i].positionsFrom! <= list[i - 1].positionsTo!) {
//           isValid = false;
//           break;
//         }
//       }
//     }
//   }

//   return isValid;
// };

const validationSchema = Yup.object().shape({
  maxReservationCount: Yup.string()
    .required("Обов'язкове поле")
    .matches(/^[0-9]+$/, 'Значення не може дорівнювати 0'),
  autoApproveList: Yup.array().of(autoApproveSchema()),
  delayMinutesToInformBySms: Yup.number()
    .positive('Значення має бути позитивним числом')
    .required('Значення має бути заповнене'),
  // .test('is-valid-auto-approve-list', 'Некоректні значення у налаштуваннях автопідтвердження броні', (value) =>
  //   validateAutoApproveList((value as IAutoApproveSetting[]) || []),
  // ),
});
export default validationSchema;
